module.exports = __webpack_public_path__ + "static/img/a086.a8f7f51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a086.jpg
// module id = fwEf
// module chunks = 0